import React from 'react';
import Modal from '../../../components/modal';
import moment from 'moment';

const ViewClaimModal = ({ show, onClose, claim }) => {
  if (!claim) return null;

  return (
    <Modal show={show} onClose={onClose} heading="Claim Details" size="lg">
      <div className="row">
        <div className="col-md-6">

          <div className="mb-3">
            <label className="form-label"><strong>Claim Type:</strong></label>
            <p>{claim?.type === 'refund' ? 'Money Back' : 'Exchange'}</p>
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Claim Date:</strong></label>
            <p>{moment(claim?.createdAt).format('DD-MM-YYYY hh:mm A')}</p>
          </div>
          <div className="mb-3">
            <label className="form-label"><strong>Mode of Payment:</strong></label>
            <p>{claim?.mode_of_payment || 'N/A'}</p>
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label"><strong>Product:</strong></label>
            <p>{claim?.FinalProductStockVariation?.FinalProduct?.name || 'N/A'}</p>
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Variant & Serial Number:</strong></label>
            <p>{claim?.FinalProductStockVariation?.variant_name || 'N/A'} ({claim?.FinalProductStockVariation?.serial_no || 'N/A'})</p>
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Claim Amount:</strong></label>
            <p>₹{(claim?.FinalProductStockVariation?.price || 0).toFixed(2)}</p>
          </div>

          
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label"><strong>Claim Reason:</strong></label>
            <p className="alert alert-dark">{claim?.reason || 'No reason provided'}</p>
          </div>
        </div>
      </div>

      {claim?.type === 'exchange' && claim?.exchange_product_name && (
        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <label className="form-label"><strong>Exchanged Product:</strong></label>
              <p>{claim?.exchange_product_name}</p>
            </div>
          </div>
        </div>
      )}

      {claim?.notes && (
        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <label className="form-label"><strong>Admin Notes:</strong></label>
              <p className="alert alert-info">{claim?.notes}</p>
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12 d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewClaimModal;